import React, { Component } from 'react'
import YouTubeReactPlayer from 'react-player/lib/players/YouTube'
import PlayerContext from "../../playerContext";

import "./YouTubePlayer.css"
import { Header, Label } from 'semantic-ui-react';
import Draggable from 'react-draggable';

class YouTubePlayer extends Component {
    static contextType = PlayerContext

    constructor(props) {
        super(props);

        this.seekSeconds = 0;
    }
    componentDidUpdate() {
        if (this.seekSeconds !== this.context.seekSeconds) {
            this.seekSeconds = this.context.seekSeconds
            this.player.seekTo(this.seekSeconds)
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log("youtube changed")
        // console.log(nextProps, nextState)
        // console.log(this.props, this.state)
        return false
    }

    ref = player => {
        this.player = player
    }

    render() {
        const playerStatus = this.context

        return (
            <Draggable >
                <div
                    style={{
                        "zIndex": "9999",
                        "position": "absolute",

                        "bottom": "20vh",
                        "left": "5vw",
                        "maxWidth": "40vw",
                        "maxHeight": "30vw"
                    }}
                >
                    <Label as='a' color='red' ribbon style={{ "left": 0 }}>
                        Drag me
        </Label>
                    {/* <Label as='a' color='red' attached="top" style={{"left":0}}>
                        Drag me
        </Label> */}
                    < YouTubeReactPlayer
                        url={`https://www.youtube.com/watch?v=${playerStatus.youtubelink}`}
                        width="100%"
                        height="100%"
                        preload = "true"
                        ref={this.ref}
                        playing={!playerStatus.paused}
                        onPause={
                            () => {
                                playerStatus.setPaused(true);
                            }
                        }

                        onPlay={
                            () => {
                                playerStatus.setPaused(false);
                            }
                        }

                        onReady={
                            () => {
                                // playerStatus.setPaused(false);
                            }
                        }

                    />
                </div>
            </Draggable>
        )
    }
}

export default YouTubePlayer